import { render, staticRenderFns } from "./ChangeOverTimeBox.vue?vue&type=template&id=14c383e4&"
import script from "./ChangeOverTimeBox.vue?vue&type=script&lang=js&"
export * from "./ChangeOverTimeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ChangeOverTimeBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c383e4')) {
      api.createRecord('14c383e4', component.options)
    } else {
      api.reload('14c383e4', component.options)
    }
    module.hot.accept("./ChangeOverTimeBox.vue?vue&type=template&id=14c383e4&", function () {
      api.rerender('14c383e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/ChangeOverTimeBox.vue"
export default component.exports